const indexItems = [
  { id: 1, title: '明星八卦', desc: '娱乐圈最新绯闻、恋情、婚变动态', count: '2,847篇', icon: 'ri-star-line', bg: 'bg-primary-100 text-primary-600' },
  { id: 2, title: '综艺内幕', desc: '热门综艺幕后故事、黑幕揭露', count: '1,693篇', icon: 'ri-tv-line', bg: 'bg-accent-100 text-accent-600' },
  { id: 3, title: '网红动态', desc: '头部网红最新动态、翻车事件盘点', count: '2,105篇', icon: 'ri-live-line', bg: 'bg-secondary-100 text-secondary-600' },
  { id: 4, title: '影视资讯', desc: '新片定档、票房战报、剧组动态', count: '1,892篇', icon: 'ri-film-line', bg: 'bg-primary-100 text-primary-600' },
  { id: 5, title: '音乐圈', desc: '新歌发布、演唱会、音乐人动态', count: '1,456篇', icon: 'ri-music-line', bg: 'bg-accent-100 text-accent-600' },
  { id: 6, title: '资本风云', desc: '娱乐公司财报、投融资、上市动态', count: '987篇', icon: 'ri-funds-line', bg: 'bg-secondary-100 text-secondary-600' },
  { id: 7, title: '社会话题', desc: '社会热点事件中的娱乐视角解读', count: '1,234篇', icon: 'ri-global-line', bg: 'bg-primary-100 text-primary-600' },
  { id: 8, title: '吃瓜日报', desc: '每日精选爆料汇总，一网打尽全天瓜', count: '3,521篇', icon: 'ri-newspaper-line', bg: 'bg-accent-100 text-accent-600' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">主题索引</h2>
          <p className="text-foreground-500 text-sm">按主题浏览，快速找到你感兴趣的爆料内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 max-w-6xl mx-auto">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#index"
              className="group flex items-start gap-4 bg-background-100 hover:bg-background-200/70 rounded-xl p-5 border border-background-200/70 transition-all duration-200 cursor-pointer"
            >
              <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${item.bg}`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="font-heading text-sm text-foreground-900 group-hover:text-primary-600 transition-colors mb-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mb-1.5 line-clamp-1">{item.desc}</p>
                <span className="text-[10px] text-foreground-400">{item.count}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}